export default "__VITE_ASSET__BT63WLDi__"